import React from 'react';
import BaseTablePage from '../../elements/BaseTablePage'
import Pagination from '../../elements/Pagination'
import { GhorePrizeTableUI } from './GhorePrizeTableUI'


export class GhorePrizeTable extends BaseTablePage {

  constructor(props) {
    super(props);
    this.getDataUrl = "api/v1/GetGhorePrize?offset=";
    this.className = "Ghore";


    var token = localStorage.getItem('token');
    this.headers =
    {
      'Content-Type': 'application/json',
      'ghoreId': this.props.ghoreId,
      'AuthorizationToken':token
    };

    

    this.onGhoreClick = this.onGhoreClick.bind(this);
  }

  onGhoreClick(e) {
//    console.log("onGhoreClick");
    if (typeof this.props.onGhoreClick === "function") {
      this.props.onGhoreClick(e,this.props.ghoreId);

    }
  }


  render() {
    if (!this.state.isLoaded) {
      return <div className="box-body"> در حال بارگذاری</div>;
    }


    return (
      <div className="container">

        <GhorePrizeTableUI data={this.state.data} onGhoreClick={this.onGhoreClick} />
        <Pagination pageNumber={this.state.pageNumber} count={this.state.count} perPageCount={this.state.pageSize} onChange={this.handleChangePage} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/tables/ghorePrize/GhorePrizeTable.js